import { useCallback } from 'react';

import { useConfiguration } from '@ocx/data-configuration';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { formatPrice } from '@ocx-app/lib/formatters/formatPrice';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { formatNegative } from '@ocx-app/lib/formatters/formatNegative';

import { PointsStrategy } from './loyalty-currency.types';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#signdisplay
export type LoyaltyCurrencySignDisplay = Exclude<Intl.NumberFormatOptionsSignDisplay, 'never' | 'always'>;

export type FormatParams = {
  signDisplay?: LoyaltyCurrencySignDisplay;
};
export type FormatLoyaltyCurrencyParams = FormatParams & {
  pointsStrategy: PointsStrategy;
  signDisplay?: LoyaltyCurrencySignDisplay;
};

export const formatLoyaltyCurrency = (points: number, params: FormatLoyaltyCurrencyParams): string => {
  if (params.pointsStrategy === PointsStrategy.Cents) {
    return formatPrice(points, {
      signDisplay: params?.signDisplay,
    });
  }

  const formatted = new Intl.NumberFormat(['en-US'], {
    style: 'decimal',
    maximumFractionDigits: 0,
    signDisplay: params?.signDisplay,
  }).format(points);

  return formatNegative(formatted);
};

export const useLoyaltyCurrencyFormat = () => {
  const pointsStrategy = useConfiguration('loyaltyCurrency.pointsStrategy');
  return useCallback(
    (points: number, params?: FormatParams) => formatLoyaltyCurrency(points, { pointsStrategy, ...params }),
    [pointsStrategy],
  );
};
